import { ROLES, LO_STO, ORGS } from "../util/constants";

const isAdmin = () => {
  const userRole = window.localStorage.getItem(LO_STO.USER_ROLE);
  return userRole === ROLES.ENTERPRISE_ADMIN || userRole === ROLES.SUKI_ADMIN;
};

const isSukiAdmin = () => {
  const userRole = window.localStorage.getItem(LO_STO.USER_ROLE);
  return userRole === ROLES.SUKI_ADMIN;
};

const isSukiUser = () => {
  const userOrgId = window.localStorage.getItem(LO_STO.ORG_ID);
  return userOrgId === ORGS.SUKI;
};

export { isAdmin, isSukiAdmin, isSukiUser };
